//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Navigate, useNavigate } from 'react-router-dom';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';
import {
  Box,
} from '@mui/material';

// === COMPONENTS ===
import { FileList } from './components/FileList/FileList';
import { FileView } from './components/FileView/FileView';

import { AppContext } from 'pages/App/components/AppContext/AppContext';

//#endregion

//-----------------------------------------------------------------
export function FileViewer() {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { user_details } = useContext( AppContext );

  const theme        = useTheme();
  const navigate     = useNavigate();

  const path_file_list = '';
  const path_file_view = '/:file_id';
  const path_task_view = '/:file_id/review';
  const path_misc      = '/*';
 
  const hasPermission = user_details.roles?.some((item) => item.RoleName === 'analyst');

  let page = localStorage.getItem('display_page');
  if( !page ) page = 'file';

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      height: `calc(100% - 5rem)`,
      overflow  : 'hidden',
      'z-index' : '0',
      backgroundColor : theme.palette.background.primary[theme.palette.mode],
    },
  }

  //#endregion

  //#region [green] Events

  if( user_details.roles.length === 0 ) {
    return null;
  }

  if( !hasPermission ) {
    navigate( '/' + page );    
  }

  //#endregion

  //#region [Main] render information
  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box sx={_styles.container}>
        <Routes>
          <Route path={ path_task_view } element={ <div />  } />
          <Route path={ path_file_view } element={ <FileView />  } />
          <Route path={ path_file_list } element={ <FileList />  } />
          <Route path={ path_misc      } element={ <Navigate to='files' replace /> } />
        </Routes>
      </Box>
    )
  }

  //#endregion

  return display();
}